export const GET_PENDING_OUTLETS = 'get_pending_outlets';
export const SET_PENDING_OUTLETS_LOADING = 'set_pending_outlets_loading';
export const SET_PENDING_OUTLETS_ERROR = 'set_pending_outlets_error';
